/** @format */

import moment from 'moment';

export const DateHelper = {
    format(date) {
        try {
            if (date) {
                return moment(date).format('YYYY-MM-DD HH:mm:ss');
            }
        } catch (e) {
            //Empty statement
        }
        return '';
    },

    formatYYYYMMDD(date) {
        try {
            if (date) {
                return moment(date).format('YYYY-MM-DD');
            }
        } catch (e) {
            //Empty statement
        }
        return '';
    },

    formatDDMMYYYY(date) {
        try {
            if (date) {
                return moment(date).format('DD-MM-YYYY');
            }
        } catch (e) {
            //Empty statement
        }
        return '';
    },

    calculatePromotionEndDay(date, duration) {
        try {
            if (date) {
                return moment(date)
                    .add(duration, 'months')
                    .endOf('month')
                    .format('YYYY-MM-DD');
            }
        } catch (e) {
            // empty
        }
        return '';
    },

    annexActivationTime(addMonths, day) {
        try {
            const m = moment();
            m.add(addMonths, 'months');
            m.set('date', day);
            return m.format('YYYY-MM-DD 00:00:00');
        } catch (e) {
            //Empty statement
        }
        return null;
    },

    dateDiff(startDate, endDate, type = 'hours') {
        return moment(endDate).diff(moment(startDate), type);
    },

    annexIsAllowDiscard(startMonth) {
        const current = moment().unix();
        const start = moment(startMonth)
            .add(annexesConstants.ANNEX_DISCARD_DAYS, 'day')
            .unix();
        return current < start;
    },

    daysDifferent(firstDate, secondDate) {
        return moment(secondDate).diff(moment(firstDate), 'days');
    },

    secondsDifferent(beginTime, endTime) {
        return moment(endTime).diff(moment(beginTime), 'seconds');
    },
};
